import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const DeepSeaBubblesAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for(let i=0; i<16; i++){
    const ang = (i/16)*Math.PI*2 + progress;
    const dst = e.maxRadius + progress * 200;
    const r = getRadiusAtAngle(ang, e, dst);
    ctx.beginPath(); ctx.arc(e.pos.x + Math.cos(ang)*r, e.pos.y + Math.sin(ang)*r, 15*(1-progress), 0, Math.PI*2); ctx.stroke();
  }
};

registerBlastAnimation('DEEP_SEA_BUBBLES', DeepSeaBubblesAnimation);
